import React from "react";
import "../styles/whyus.css"; // ✅ reuse existing styles
import pizzaIcon from "../assets/pizza-icon.svg";

export default function Dessert() {
  return (
    <section className="whyus-section">
      <div className="container">
        <div className="row align-items-center p-4 p-lg-0">
          {/* Left: Image */}
          <div className="col-lg-6 p-lg-5">
            <div className="whyus-image-wrap pb-5 pb-lg-0">
              <img
                src="/images/Oriaspalacsinta.webp"
                alt="Óriáspalacsinta desszert"
                className="whyus-image"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="col-lg-6 p-lg-5">
            <div className="whyus-content">
              <h2>
                <span className="highlight">Ideális desszert</span> pizzák és
                gyros tálak mellé
              </h2>

              <p>
                Óriáspalacsintáinkat hagyományos módon, nagy méretben sütjük, és
                ínycsiklandó csokiöntettel díszítjük.
              </p>

              <ul className="whyus-list">
                <li>
                  <img src={pizzaIcon} alt="" className="icon" />
                  Pizzáinkat és gyros táljainkat menüben is rendelheted, ahol az
                  óriáspalacsinta mellé ajándék üdítőt kapsz. Egészítsd ki a
                  rendelésed ezzel a megunhatatlan desszerttel, és tedd teljessé
                  az élményt!
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer text under the section */}
        <div className="dessert-footer pb-3">
          <h3>
            <span className="highlight">Rendelj Debrecenben</span>{" "}
            házhozszállításra pizzát, gyros tálat és óriáspalacsintát!
          </h3>
        </div>
      </div>
    </section>
  );
}
